// @flow
import fp from "lodash/fp"

import { INSURANCE_NUMBERS } from "common/consts/insurance"
import type { InsurancePassengers } from "booking/services/additionalServices/services/insurance/types"
import type { PassengerFields } from "booking/scenes/ReservationForm/services/fields/passengersFields"

const mapWithIndex = fp.map.convert({ cap: false })

export const createInsuranceQuery = (
  passengers: PassengerFields,
  insurancePassengers: InsurancePassengers,
  insuranceEnabled: boolean,
): string => {
  if (!insuranceEnabled || !passengers) {
    return ""
  }

  return fp.pipe(
    mapWithIndex((x, i) =>
      insurancePassengers[i] && INSURANCE_NUMBERS.hasOwnProperty(insurancePassengers[i])
        ? INSURANCE_NUMBERS[insurancePassengers[i]]
        : "0",
    ),
    fp.dropRightWhile(x => x === "0"),
    fp.join("-"),
  )(passengers)
}
